import { ServiceType } from 'types';
import { baseQuery } from '../baseQuery';

type ServiceCreateParams = {
  appointmentId: number;
  serviceType: ServiceType;
  searchId: number;
  technicianNote: string;
  billtoId?: number;
  overrideTime?: string;
  serviceSelectionId: number;
  technicianId: number;
  callbackTaskId?: number;
};

export const postService = async ({
  appointmentId,
  serviceType,
  searchId,
  technicianNote,
  billtoId,
  overrideTime,
  serviceSelectionId,
  technicianId,
  callbackTaskId,
}: ServiceCreateParams) => {
  // Full envelope, not just the inner `data` — the response also carries
  // geekcover_signup_failed/geekcover_tc_not_sent flags as siblings of `data`.
  return await baseQuery('service', {
    type: 'POST',
    body: {
      hold_appointment_id: appointmentId,
      service_type: serviceType,
      search_history_id: searchId,
      technician_note: technicianNote,
      billto_id: billtoId,
      // availability override
      override_appointment_time: overrideTime,
      service_selection_id: serviceSelectionId,
      technician_id: technicianId,
      ...(callbackTaskId !== undefined ? { callback_task_id: callbackTaskId } : {}),
    },
  });
};
